import { Button } from "@sellar-io/components";
import { useEffect, useEffectEvent, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router";
import { SpinnerLegacy } from "../../../components";
import {
  Dialog,
  DialogNavigation,
  DialogCTA,
} from "../../../components/modal/Dialog";
import * as ROUTES from "../../../constants/routes";
import { LOGIN } from "../../../constants/routes";
import { useSellarUser } from "../../../hooks";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { useJwtExecute } from "../../../hooks/api/v2/jwt/useJwtExecute";
import { useSignupContext } from "../../../hooks/useSignupContext.shared";
import { withSearchParams } from "../../../utils/withSearchParams";

export const JwtAction = () => {
  const [searchParams] = useSearchParams();
  const { jwt } = Object.fromEntries(searchParams);

  const { hasAcceptedTermsAndConditions } = useSignupContext();
  const location = useLocation();
  const navigate = useNavigate();
  const jwtExecuteMutation = useJwtExecute();
  const [message, setMessage] = useState("");
  const [modalActive, setModalActive] = useState(false);
  const { changeBusiness } = useSellarUser();

  const executeJWT = useEffectEvent(async () => {
    if (!jwt) throw new Error("Cannot find JWT");

    jwtExecuteMutation.mutate(
      { jwt, hasAcceptedTermsAndConditions },
      {
        onSuccess: (response) => {
          changeBusiness(response.BusinessId);
          navigate(ROUTES.LANDING);
        },
        onError: (e) => {
          let message = apiV2AssertError(e)?.response?.data.message;

          if (!message) {
            if (apiV2AssertError(e)?.response?.status === 401) {
              message = "Log in to claim this business.";
            } else {
              message = "Unknown Error";
            }
          }
          setMessage(message);
          setModalActive(true);
        },
      },
    );
  });

  useEffect(() => {
    if (!jwt) {
      // must return void not Promise<void>
      navigate(LOGIN);
      return;
    }

    executeJWT();
  }, [navigate, jwt]);

  return (
    <>
      <SpinnerLegacy />
      <Dialog active={modalActive}>
        <DialogNavigation title={message} />
        <DialogCTA>
          <Button
            onClick={() => {
              setModalActive(false);
              navigate(
                withSearchParams(LOGIN, {
                  continue: `${location.pathname}${location.search}`,
                }),
                { replace: true },
              );
            }}
          >
            Log in
          </Button>
        </DialogCTA>
      </Dialog>
    </>
  );
};
